onComplete(function() {
	// The contact button in the header is an editable image whose link points at the information popup.
	const opener = document.querySelector('[data-purpose="open-information"]');
	if (!opener) {
		return;
	}

	document.addEventListener('click', function(event) {
		const link = event.target.closest('a[href$="#informatie-aanvragen"]');
		if (link && !document.body.hasAttribute('data-editor-mode')) {
			event.preventDefault();
			opener.click();
		}
	});
});

onInteractive(function() {
	// The review button lives in editable text, which cannot carry data-toggle, so its link target opens the form.
	const form = document.getElementById('review-schrijven');
	if (!form || document.body.hasAttribute('data-editor-mode')) {
		return;
	}

	document.querySelectorAll('a[href$="#review-schrijven"]').forEach(function(button) {
		button.setAttribute('aria-controls', 'review-schrijven');
		button.setAttribute('aria-expanded', 'false');
		button.addEventListener('click', function(event) {
			event.preventDefault();
			const open = form.classList.toggle('show');
			button.setAttribute('aria-expanded', open ? 'true' : 'false');
		});
	});
});

onInteractive(function() {
	// The review overview shows every review in full, so the feed's shortened previews are expanded right away.
	document.querySelectorAll('.content-subtemplate-reviews .review-item-preview [data-shorten-text-clone] > button').forEach(function(button) {
		button.click();
	});
});
